// Chain card thumbnail URL. The chain edge sends the poster
// filename as `image`; the URL is built the same way as the current experience's
// poster (ExperienceMetadata.getAssetUrl), so it resolves on the player's own
// asset host. Absent filename → null (the CSS gradient placeholder shows).
// Shared by UpNextList and NextVideoBlock so both build the URL identically.
import type ExperienceData from "@/modules/ExperienceData";

export function chainThumbUrl(
  experienceData: ExperienceData | null | undefined,
  filename: string | null | undefined,
): string | null {
  if (
    !filename ||
    !experienceData ||
    !experienceData.metadata ||
    !experienceData.metadata.getAssetUrl
  ) {
    return null;
  }
  return experienceData.metadata.getAssetUrl(filename);
}
